module.exports = __webpack_public_path__ + "static/media/lifstory.cb342455.svg";